import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Box, Text } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils, ROOT_BASE_URL } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const GaransiFotoComponent = ({
  stateData,
  fnClickPhoto,
  fnOnChanged,
  stateWithDeletePhoto = true
}) => {

  const mountedRef = React.useRef(true);
  const heightImage = 150;

  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorDeleteFoto: 'garansiSelected-5',
  })

  const [data, setData] = React.useState({
    data: [],

    fotoDeleteModal: false,
    fotoDeleteGaransiId: '',
    fotoDeleteGaransiDetilId: '',
    fotoDeleteGaransiFotoId: '',
    fotoDeleteName: '',
    fotoDeleteLoading: false,

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const deleteFoto = () => {
    setData(d => ({ ...d, fotoDeleteLoading: true }));

    const formDT = new FormData();
    const formDTHeader = { 'Content-Type': 'application/json' }

    formDT.append('json_token', loginContext.syswebapp);
    formDT.append('garansi_id', data.fotoDeleteGaransiId);
    formDT.append('garansi_detil_id', data.fotoDeleteGaransiDetilId);
    formDT.append('garansi_foto_id', data.fotoDeleteGaransiFotoId);
    formDT.append('garansi_foto_name', data.fotoDeleteName);
    formDT.append('garansi_item_status', stateData.garansiItemStatus);

    axios({
      method: 'post',
      url: BE_API_TWO + '/delete_garansi_item_foto',
      data: formDT,
      headers: formDTHeader,
    }).then((response) => {
      if (!mountedRef.current) return null;

      setData(d => ({ ...d, fotoDeleteLoading: false, fotoDeleteModal: false }));

      if (response.data.flag_status === 'isset') {
        fnOnChanged(response.data.data);
      }

      if (response.data.flag_status === 'error') {
        notifications.show({
          id: notificationId.current.errorDeleteFoto,
          title: utils.notification.warning.caption,
          message: response.data.pesan,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      }

      if (response.data.flag_status === 'no-data') {
        setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: true,
            content: 'Data tidak ditemukan.',
            show: true
          }
        }))
      }

      if (response.data.flag_status === 'invalid-json-token') {
        handleSetLoginContext(null);
      }

      if (response.data.flag_status === 'user-inactive') {
        handleSetLoginContext(null);
      }
    }).catch(error => {
      if (!mountedRef.current) return null;

      setData(d => ({
        ...d,
        fotoDeleteLoading: false,
        fotoDeleteModal: false
      }))

      notifications.show({
        id: notificationId.current.errorDeleteFoto,
        title: utils.notification.warning.caption,
        message: error.message,
        color: utils.notification.warning.color,
        icon: utils.notification.warning.icon,
        withBorder: true,
        autoClose: true,
      })
    })
  }

  return (
    <React.Fragment>
      {Array.isArray(stateData.dataFoto) && stateData.dataFoto.length > 0 &&
        <Carousel
          withIndicators={false}
          withControls={Array.isArray(stateData.dataFoto) && (stateData.dataFoto.length > 1)}
          height={heightImage}
          slideSize="33.333333%"
          slideGap="xs"
          loop={false}
          align="start"
          mt='md'
        >
          {Array.isArray(stateData.dataFoto) && Object.keys(stateData.dataFoto).map((keyFB, index) => {
            return (
              <Carousel.Slide key={keyFB}>
                <Box
                  sx={{
                    position: 'relative',
                    height: heightImage + 'px'
                  }}
                >
                  <img
                    alt={`foto-item-${index}`}
                    src={`${ROOT_BASE_URL}${stateData.dataFoto[keyFB].stock_garansi_foto_name}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}

                    onClick={() => fnClickPhoto({
                      images: stateData.dataFoto,
                      title: 'Foto Item',
                      index: keyFB,
                      fieldName: 'stock_garansi_foto_name',
                      show: true,
                    })}
                  />

                  {stateWithDeletePhoto ?
                    <Box
                      px='.5rem'
                      sx={(tema) => ({
                        height: '30px',
                        backgroundColor: tema.fn.rgba('#404040', 0.75),
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        cursor: 'pointer'
                      })}

                      onClick={() => setData(d => ({
                        ...d,
                        fotoDeleteGaransiId: stateData.dataFoto[keyFB].stock_garansi_id,
                        fotoDeleteGaransiDetilId: stateData.dataFoto[keyFB].stock_garansi_detil_id,
                        fotoDeleteGaransiFotoId: stateData.dataFoto[keyFB].stock_garansi_foto_id,

                        fotoDeleteName: stateData.dataFoto[keyFB].stock_garansi_foto_name,
                        fotoDeleteModal: true
                      }))}
                    >
                      <Text color="#fff">
                        {String(Number(keyFB) + 1)}
                      </Text>

                      <IconTrash
                        size={18}
                        color='#fff'
                      />
                    </Box>
                    :
                    <Box
                      px='.5rem'
                      sx={(tema) => ({
                        height: '30px',
                        backgroundColor: tema.fn.rgba('#404040', 0.75),
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      })}
                    >
                      <Text color="#fff">{String(Number(keyFB) + 1)}</Text>
                    </Box>
                  }
                </Box>
              </Carousel.Slide>
            )
          })}
        </Carousel>
      }

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />

      <ModalTakeAction
        stateShow={data.fotoDeleteModal}
        fnHide={() => setData(d => ({ ...d, fotoDeleteModal: false }))}

        stateHideOnClickOutSide={true}
        stateTitle={String('Confirmation').toUpperCase()}
        stateOverlayZIndex={201}

        stateButtonClosePx='md'

        stateButtonActionCaption='Hapus'
        stateButtonActionPx='xs'
        stateButtonActionColor="red"
        stateButtonActionLoading={data.fotoDeleteLoading}
        fnButtonAction={deleteFoto}
      >
        <Text size='sm'>
          Hapus foto ini ?
        </Text>
      </ModalTakeAction>
    </React.Fragment>
  )
}

export default React.memo(GaransiFotoComponent);